module.exports = __webpack_public_path__ + "1df390799b15a94872f198189360a1a6.svg";